import { Entity, Key } from '@briebug/ngrx-auto-entity';

@Entity({
  modelName: 'ReputationScore',
  uriName: 'reputation-score',
})
export class ReputationScore {
  @Key userId?: string;
  reputationScore?: number;
}

export enum ReputationTier {
  Rookie = 'Rookie',
  Intermediate = 'Intermediate',
  Experienced = 'Experienced',
  Proficient = 'Proficient',
  Expert = 'Expert',
  Master = 'Master',
  Artisan = 'Artisan',
  EliteArtisan = 'Elite Artisan',
}

export const REPUTATION_TIERS_ORDERED: ReputationTier[] = [
  ReputationTier.Rookie,
  ReputationTier.Intermediate,
  ReputationTier.Experienced,
  ReputationTier.Proficient,
  ReputationTier.Expert,
  ReputationTier.Master,
  ReputationTier.Artisan,
  ReputationTier.EliteArtisan,
];

export const getTierIdFromTier = (tier: ReputationTier): number => {
  return REPUTATION_TIERS_ORDERED.indexOf(tier);
};

export const getTierFromTierId = (tierId: number): ReputationTier | undefined => {
  return REPUTATION_TIERS_ORDERED[tierId];
};

export const getTierFromScore = (score: number): ReputationTier => {
  if (score < 20) return ReputationTier.Rookie;
  if (score < 40) return ReputationTier.Intermediate;
  if (score < 50) return ReputationTier.Experienced;
  if (score < 60) return ReputationTier.Proficient;
  if (score < 70) return ReputationTier.Expert;
  if (score < 80) return ReputationTier.Master;
  if (score < 90) return ReputationTier.Artisan;
  return ReputationTier.EliteArtisan;
};
